/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import React from 'react';
import { motion } from 'framer-motion';
import { useViewport } from '@vlinder-web/viewport-provider-react';
import RenderWhen from '@vlinder-web/react-when-module-react';
import _ from 'lodash';
import * as S from './styles';
import { Banner } from './styles';

export interface IShelvesProps {
  products?: any[];
  noOfProductsInShelf?: number;
  onProductClick?(product: any): void;
}

const getNumberOfProducts = (
  bp?: 'xs' | 'sm' | 'md' | 'lg' | 'xl',
  no?: number
) => {
  if (no && no === 1) {
    return 1;
  }
  if (no && bp && (bp == 'xs' || bp == 'sm')) {
    return 2;
  }
  return no;
};

export const Shelves = ({
  products,
  noOfProductsInShelf,
  onProductClick,
}: IShelvesProps) => {
  const { bp } = useViewport();
  const _comp: any = [];
  const productChunk = _.chunk(
    products,
    getNumberOfProducts(bp, noOfProductsInShelf)
  );

  const _onBannerClick = (product: any) => {
    if (onProductClick) {
      onProductClick(product);
    }
  };

  const _renderProductEach = (products?: any[]) => {
    const _res: any = [];
    if (products && products?.length > 0) {
      for (const product of products) {
        _res.push(
          <motion.div
            whileHover={{
              scale: 1.1,
              transition: { duration: 0.2 },
            }}
            onClick={_onBannerClick.bind(null, product)}
          >
            <S.Banner src={product?.banner} />
          </motion.div>
        );
      }
    }
    return _res;
  };

  const _renderProductChunk = () => {
    if (productChunk && productChunk.length > 0) {
      for (const productEach of productChunk) {
        _comp.push(
          <>
            <S.Box>{_renderProductEach(productEach)}</S.Box>
            <S.Shelf />
          </>
        );
      }
    }
    return _comp;
  };
  return <>{_renderProductChunk()}</>;
};

Shelves.defaultProps = {
  products: [],
  noOfProductsInShelf: 3,
};
